/* tslint:disable */

declare var Object: any;
export interface TtademplocationServiceInterface {
  "id"?: number;
}

export class TtademplocationService implements TtademplocationServiceInterface {
  "id": number;
  constructor(data?: TtademplocationServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TtademplocationService`.
   */
  public static getModelName() {
    return "TtademplocationService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TtademplocationService for dynamic purposes.
  **/
  public static factory(data: TtademplocationServiceInterface): TtademplocationService{
    return new TtademplocationService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TtademplocationService',
      plural: 'TtademplocationServices',
      path: 'TtademplocationServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/TtademplocationService.ts